import { render } from "./ViewDossiers.vue?vue&type=template&id=45f8ea20&scoped=true&ts=true"
import script from "./ViewDossiers.vue?vue&type=script&lang=ts"
export * from "./ViewDossiers.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/Chirbou/isolation/client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45f8ea20"]])

export default __exports__